import { useContext } from 'react';
import { LanguageContext } from '../../contexts/LanguageContext';
import { translations } from './Loading.translations';

// B7 slice 2 (task 2026-10-28-002): Lao by default, as ProtectedRoute's spinner. Read the context
// directly (not useLanguage) so the spinner still renders where no LanguageProvider wraps it.
export default function Loading() {
  const language = useContext(LanguageContext)?.language ?? 'lo';
  const t = translations[language] ?? translations.lo;
  return (
    <div className="flex items-center justify-center py-12" lang={language}>
      <div className="spinner"></div>
      <span className="ml-3 text-gray-600">{t.loading}</span>
    </div>
  );
}
